import type { MouseEvent } from "react";
import { quickEntries } from "@/mocks/home";
import Reveal from "@/components/feature/Reveal";

const toneStyles: Record<string, { bubble: string; badge: string }> = {
  primary: { bubble: "bg-primary-100 text-primary-700", badge: "bg-primary-500 text-background-50" },
  secondary: { bubble: "bg-secondary-100 text-secondary-800", badge: "bg-secondary-500 text-background-50" },
  accent: { bubble: "bg-accent-100 text-accent-900", badge: "bg-accent-500 text-primary-950" },
};

const entryBadges: Record<string, string> = {
  "entry-archive": "打包可下载",
  "entry-subscribe": "免费订阅",
};

export default function QuickEntries() {
  const handleAnchor = (event: MouseEvent<HTMLAnchorElement>, hash: string) => {
    event.preventDefault();
    const target = document.querySelector(hash);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="bg-background-50 pb-4 pt-12 md:pb-8 md:pt-16">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-8">
        <div className="mb-6 flex flex-col gap-2 md:mb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-label text-xs tracking-[0.3em] text-primary-600">QUICK ACCESS</p>
            <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">四种方式，快速进入</h2>
          </div>
          <p className="font-label text-sm text-foreground-500">想怎么开始都行，入口都放这儿了。</p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {quickEntries.map((entry, index) => {
            const tone = toneStyles[entry.tone] ?? toneStyles.primary;
            const badge = entryBadges[entry.id];
            return (
              <Reveal key={entry.id} delay={index * 80}>
                <a
                  href={entry.href}
                  onClick={(event) => handleAnchor(event, entry.href)}
                  className="group relative flex h-full cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 md:p-6"
                >
                  <div className="flex items-start justify-between">
                    <span className={`flex h-12 w-12 items-center justify-center rounded-md md:h-14 md:w-14 ${tone.bubble}`}>
                      <i className={`${entry.icon} text-2xl`}></i>
                    </span>
                    <i className="ri-arrow-right-up-line text-xl text-foreground-300 transition-all duration-300 group-hover:text-primary-500"></i>
                  </div>

                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{entry.title}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{entry.desc}</p>

                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                    <span className="font-label text-xs text-foreground-500">{entry.meta}</span>
                    {badge && (
                      <span className={`rounded-full px-2.5 py-1 font-label text-[11px] ${tone.badge}`}>{badge}</span>
                    )}
                  </div>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}